
import React, { useEffect } from "react";
import { Toaster } from "@/components/ui/toaster";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/language";
import { ThemeProvider } from "next-themes";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import { loadRegionData } from "./data/regions-data";
import OrientationPrompt from "./components/orientation/OrientationPrompt";
import { useIsMobile } from "./hooks/use-mobile";
import "../src/styles/funding-labels.css";

// Create QueryClient instance
const queryClient = new QueryClient();

const AppContent = () => {
  const { isMobile } = useIsMobile();
  
  // Load region data on app initialization
  useEffect(() => {
    console.log("App initialized, loading region data...");
    loadRegionData().catch(error => {
      console.error("Failed to load region data:", error);
    });
  }, []);

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
      {isMobile && <OrientationPrompt />}
    </>
  );
};

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider attribute="class" defaultTheme="light">
        <LanguageProvider>
          <AppContent />
        </LanguageProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;
